import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, Subject, Subscription } from "rxjs";
import { EstatusJSON } from "../../models/EstatusJSON";
import { environment } from "src/environments/environment";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../models/Filter/FilterRequest";
import { IApiBase } from "./Interface/IApiBase.interface";

@Injectable({
  providedIn: "root",
})
export class DownloadsCenterAPIService implements IApiBase{
  
  configUrl: string;
  public Result;
  estatus: EstatusJSON;
  constructor(private http: HttpClient) {
    this.configUrl = environment.host;
    this.estatus = new EstatusJSON();
  }
  delete(id: any) {
    throw new Error("Method not implemented.");
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }


  //paginacion
  getFilterValues(request : FilterRequest[]) {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/DownloadsCenter/GetFilterValues", request);
  }

  getPage(pageRequest: CatalogPaginationRequest) {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/DownloadsCenter/GetPage", pageRequest);
  }

  getCount(pageRequest: CatalogPaginationRequest) {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/DownloadsCenter/GetCount", pageRequest);
  }

  
}
